<script setup>
defineProps({ variant: { type: String, default: "primary" }, as: { type: String, default: "button" }, disabled: Boolean })
</script>

<template>
  <component
    :is="as"
    :disabled="disabled"
    :class="[
      variant === 'primary' && 'btn-primary px-4 py-2',
      variant === 'outline' && 'btn-outline px-4 py-2',
      variant === 'destructive' && 'btn-destructive px-4 py-2'
    ]"
  >
    <slot />
  </component>
</template>
